import $ from 'jquery';

export default function form() {
  $('.wpcf7-submit').on('click', function () {
    $('.wpcf7-validates-as-required').attr('required','true');
  });
}
